import { useGlintsVIPMembershipInfo } from '../../components/GlintsVIPMembershipInfo/hooks/useGlintsVIPMembershipInfo';
import useGetFeatureCount from './useGetFeatureCount';
import { useGetFeatureEnabledForCountry } from './useGetFeatureEnabledForCountry';
import { useGetSessionCompany } from './useGetSessionCompany';
import useIsMonthlyQuotaEnabled from './useIsMonthlyQuotaEnabled';

type Params = {
  skipVIPMembershipCheck?: boolean;
};

type FeatureVariant = 'enabled' | 'disabled' | 'ignored';

export default function useIsProfileLimitAccessEnabled(
  params?: Params
): boolean {
  const { sessionCompany } = useGetSessionCompany();
  const { vipMembershipInfo } = useGlintsVIPMembershipInfo();
  const variant = sessionCompany?.fullProfileAccessStatus?.variant
    ?.value as FeatureVariant;
  const { isShortListLimited } = useGetFeatureCount();
  const isMonthlyQuotaEnabled = useIsMonthlyQuotaEnabled();

  const vipMembershipCheck = params?.skipVIPMembershipCheck
    ? true
    : !vipMembershipInfo.isActive;

  const { isProfileLimitAccessEnabled } = useGetFeatureEnabledForCountry();

  if (
    (isShortListLimited || isMonthlyQuotaEnabled) &&
    isProfileLimitAccessEnabled
  ) {
    return true;
  }

  return Boolean(
    variant === 'enabled' &&
      sessionCompany &&
      isProfileLimitAccessEnabled &&
      vipMembershipCheck
  );
}
